<script setup lang="ts">
import type { EventModel } from '@/types/models/EventModel'
import {
    EditableFieldWrapper,
    EditableStringField,
    InformationBaseCard,
    StackLayout
} from '@rfc/rfc-components-library'
import TimezoneSelector from '../../components/TimezoneSelector.vue'

type Props = {
    data: Partial<EventModel>
    editMode?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<EventModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard :label="$t('event.detail.informations.informationsTitle')" class="w-full">
        <StackLayout direction="column" :gap="8" class="w-full">
            <EditableStringField
                :label="$t('event.model.name')"
                :modelValue="data?.name"
                :editMode="editMode"
                boldLabel
                required
                @change="$emit('change', { name: $event })" />
            <EditableStringField
                :label="$t('checkpoint.model.comments')"
                :modelValue="data?.comments"
                :editMode="editMode"
                boldLabel
                @change="$emit('change', { comments: $event })" />
            <EditableFieldWrapper
                :label="$t('event.model.tz')"
                :modelValue="data.tz"
                boldLabel
                :editMode="editMode">
                <TimezoneSelector :data="data?.tz" @change="$emit('change', $event)" />
            </EditableFieldWrapper>
        </StackLayout>
    </InformationBaseCard>
</template>
